<template>
  <data-iterator
    :list="antecedents"
    add-new-text="Ajouter un antécédent"
    :live="liveListe"
    :icon="$getIcon('judiciaire')"
    :valids="valids"
    ref="dataIterator"
  >
    <template v-slot:show-mode="{ item, index }">
      <p class="mb-0">Preuve {{ index + 1 }}</p>
    </template>
    <template v-slot:edit-mode="{ item }">
      <FileInput :code="'preuve_' + codeInfraction" :file="item.preuve" :live="liveSasAntecedent(6903, item)"></FileInput>
    </template>
  </data-iterator>
</template>

<script>
export default {
  props: {
    antecedents: { type: Array },
    codeInfraction: { type: String, required: true },
    sasId: { type: String, required: true },
    valids: { type: Array, default: () => [] }
  },
  computed: {
    liveListe() {
      return {
        endpoint: "sas-antecedents-judiciaires",
        sasId: this.sasId,
        payload: { codeInfraction: this.codeInfraction }
      }
    }
  },

  methods: {
    liveSasAntecedent(cle, item) {
      return { endpoint: "sas-antecedents-judiciaires", cle: cle, fileId: item.id }
    }
  }
}
</script>

<style>
</style>